"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["label", "shape", "size", "color", "outline", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Badge component is mostly used in association with another UI element to provide textual or numerical informations.
 */
var Badge = function Badge(_ref) {
  var label = _ref.label,
    shape = _ref.shape,
    size = _ref.size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    outline = _ref.outline,
    className = _ref.className,
    children = _ref.children,
    attributes = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = (0, _clsx.default)('uk-badge', "badge--" + shape, size !== 'default' && size, "uk-bdcolor--" + color, outline ? "uk-outline--" + color : "uk-bgcolor--" + color, className);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: classes
  }, attributes), label || children);
};
Badge.propTypes = {
  /**
   * Content of the Badge
   */
  label: _propTypes.default.string,
  /**
   * Shape of the Badge
   */
  shape: _propTypes.default.oneOf(['square', 'round']),
  /**
   * Size of the Badge
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large']),
  /**
   * Background-color of the Badge (or border-color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'clear']),
  /**
   * Invert styling colors of the Badge
   */
  outline: _propTypes.default.bool
};
Badge.defaultProps = {
  shape: 'round',
  size: 'default',
  color: 'primary',
  outline: false
};
var _default = exports.default = Badge;